import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { catchError, from, Observable, switchMap } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { AuthFacadeService } from './auth-facade.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private oAuthService: OAuthService, private authFacadeService: AuthFacadeService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes('/connect/token') || 
			req.url.includes('/api/account') ||
			req.url.includes('/api/app/identity-user-app-service-ex') ||
			req.url.startsWith('https://bargain-chemist-staging-store.myshopify.com') ||
			req.url.startsWith('https://bargainchemist.co.nz') ||
			req.url.includes('/.well-known/') ||
			req.url.includes('/api/abp/') ||
			req.url.includes('/api/app/features')
		) 
		{
            // Skip auth logic for token endpoint
            return next.handle(req);
        }

		console.debug ('Checking auth for request to:', req.url);

        return from(this.authFacadeService.hasLoggedIn(true)).pipe(
            switchMap((loggedIn) => {
                if (loggedIn) {
                    // Always get the latest token after possible refresh
                    const accessToken = this.oAuthService.getAccessToken();
                    if (accessToken) {
                        const authReq = req.clone({
                            setHeaders: {
                                Authorization: `Bearer ${accessToken}`
                            }
                        });
						console.debug('Added Authorization header to request for:', req.url);
                        return next.handle(authReq);
                    }
                }
				console.debug('Calling next.handle without auth header for:', req.url);
                return next.handle(req);
            }),
            catchError((err) => {
                // If hasLoggedIn or token refresh fails, proceed without auth header
                console.error('[AuthInterceptor] Error during login check or token refresh:', err);                
                return next.handle(req);
            })
        );
    }
}
